/* @flow */

export const usernameFieldMaxLength = 100;
export const passwordFieldMaxLength = 100;
export const firstNameFieldMaxLength = 100;
export const lastNameFieldMaxLength = 100;
export const extraFieldNameFieldMaxLength = 100;
export const supportMessageFieldMaxLength = 1000;
